import React from 'react';
import { rhythm } from '../utils/typography';


import Anchor from "./mdx/Anchor"



export default function GetInTouch(){
  return(
    <div style={{
      margin:`${rhythm(2)} 0`
    }}>
      <h2 style={{fontFamily: "Reenie Beanie"}}>Get in touch</h2>
      Hey, have any suggestions, questions or concerns, Feel free to 
        <Anchor href="mailto:jaymgurav@gmail.com" rel="noopener noreferrer" target="_blank">Mail me</Anchor>
      . You can also find me on 
        <Anchor rel="noopener noreferrer" href="https://twitter.com/JayMGurav" target="_blank">Twitter</Anchor>
      , 
        <Anchor rel="noopener noreferrer" href="https://github.com/jaymgurav/" target="_blank">Github</Anchor>
       and 
        <Anchor rel="noopener noreferrer" href="https://www.linkedin.com/in/jaymgurav/" target="_blank">Linkedin</Anchor>
      . Help me make this better drop me a message and I'll get back to you soon Thanks!🎉
    </div>
  )
}